import { render, staticRenderFns } from "./CoWelcomePage.vue?vue&type=template&id=109495ad&"
import script from "./CoWelcomePage.vue?vue&type=script&lang=ts&"
export * from "./CoWelcomePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports